import { FadeUp, MaskLines, Eyebrow } from "../site/Motion";
import { Download, Ticket } from "lucide-react";
import { InstallApp } from "../site/InstallApp";

export const APP_SCREEN_BG = "/img/app-bg.jpg";

const Phone = () => (
  <div data-testid="iphone-mockup" className="relative mx-auto w-[260px] rotate-[-4deg] rounded-[46px] bg-[#111] p-[10px] shadow-[0_50px_100px_-30px_rgba(0,0,0,.6)] ring-1 ring-white/10 transition-transform duration-700 hover:rotate-0 md:w-[290px]">
    <div className="relative aspect-[9/19.5] overflow-hidden rounded-[38px] bg-black">
      <img src={APP_SCREEN_BG} alt="Pantalla de la app Santiagueño" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-transparent to-black/85" />
      <div className="absolute left-1/2 top-2.5 h-7 w-24 -translate-x-1/2 rounded-full bg-black" />
      <div className="absolute inset-x-0 top-12 px-5">
        <img src="/brand/logo-white.png" alt="" className="h-6 w-auto" />
        <p className="mt-4 font-display text-2xl leading-none text-white">Tu próximo viaje empieza acá.</p>
      </div>
      <div className="absolute inset-x-3 bottom-4 rounded-2xl bg-white/95 p-4 backdrop-blur">
        <p className="flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] text-[var(--forest)]"><Ticket className="h-3 w-3" /> SG-4F7K2M</p>
        <p className="mt-1 font-display-up text-base leading-tight">Buenos Aires → Santiago</p>
        <div className="mt-2 flex justify-between font-mono text-[11px] text-[var(--muted-ink)]"><span>19:00 hs</span><span>Butaca 52</span><span>Cama</span></div>
      </div>
    </div>
  </div>
);

export const Flota = () => (
  <section data-testid="home-flota" className="bg-[var(--paper)] py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Eyebrow>Nuestra flota</Eyebrow>
      <h2 className="mt-5 font-display text-4xl md:text-6xl"><MaskLines inView lines={["Doble piso,", "de frente al camino."]} /></h2>
      <div className="mt-12 grid gap-4 lg:grid-cols-12">
        <FadeUp className="lg:col-span-7">
          <div className="group relative h-full min-h-[320px] overflow-hidden rounded-[28px] bg-[var(--ink)] md:min-h-[560px]">
            <img src="/img/bus-front-dusk.jpg" alt="Frente del ómnibus Santiagueño en la terminal" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <p className="absolute bottom-6 left-6 font-mono text-xs tracking-[0.25em] text-[var(--lime)]">METALSUR · DOBLE PISO · STARLINK</p>
          </div>
        </FadeUp>
        <FadeUp delay={0.1} className="lg:col-span-5">
          <div className="grain relative flex h-full min-h-[560px] flex-col items-center justify-center overflow-hidden rounded-[28px] bg-[var(--forest)] px-6 py-12">
            <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[var(--lime)]/25 blur-3xl" />
            <InstallApp testid="phone-install-app" className="group/phone relative cursor-pointer rounded-[46px] text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--lime)]">
              {(installed) => (
                <>
                  <Phone />
                  {!installed && (
                    <span className="absolute -bottom-4 left-1/2 inline-flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-[var(--lime)] px-5 py-2.5 text-sm font-bold text-[var(--ink)] shadow-lg transition-transform duration-200 group-hover/phone:scale-105">
                      <Download className="h-4 w-4" /> Tocá para instalar la app
                    </span>
                  )}
                </>
              )}
            </InstallApp>
            <p className="relative mt-12 max-w-xs text-center text-white/85">Tu pasaje siempre a mano: código, butaca y horario en el celular.</p>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
